import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import DialingInput from '../dialingInput';
import Keypad from '../keypad/keypad';
import Button from 's2s-button';
import CallControls from '../callControls';
// import { track } from 's2s-app-service';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../../js/utilities';


import useCallInfo from "../../hooks/callInfo";

const composedHoc = compose(injectIntl);
const ComposedButton = composedHoc(Button);
const ComposedCallControls = composedHoc(CallControls);
const ComposedKeypad = composedHoc(Keypad);
const ComposedDialingInput = composedHoc(DialingInput);

const UserActions = styled.div`
  width : 100%;
`;

const FooterControls = styled.div`
  align-items : center;
  background-color : ${colorGrid.gray0};
  border-top : 1px solid ${colorGrid.gray3};
  display : flex;
  height : 56px;
  justify-content : space-between;
  padding-left : 16px;
  padding-right : 16px;
`;

const HangUpButton = styled(ComposedButton)`
  background-color: #c70816;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  justify-content: center;
  height: 40px;
  letter-spacing: 1.25px;
  text-transform: uppercase;
  width: 50%;
  
  &:hover {
    background-color: #85050f;
  }
`;

const PhoneButton = styled(ComposedButton)`
  display : flex;
  justify-content : center;
  width : ${props => {
    return props.userControlStatus === "zero" ? "88px" : "calc(50% - 16px)";
  }};
`;

const CancelButton = styled(ComposedButton)`
  background-color: ${colorGrid.gray0};
  border: 1px solid #a7b4e9;
  color: #243991;
  display: inline-flex;
  font-family: Open Sans;
  font-weight: 700;
  justify-content: center;
  letter-spacing: 1.25px;
  margin-right: 16px;
  text-transform: uppercase;
  width: 50%;

  &:hover {
    background-color: #d3d9f4;
  }
`;

const DialingInputContainer = styled.div`
  align-items: center;
  background-color : ${colorGrid.gray2};
  color: ${colorGrid.gray5};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  height: 30px;
  padding: 10px;
  position : relative;
`;

const DTMFToneContainer = styled.div`
  align-items: center;
  background-color: ${colorGrid.gray0};
  border: none;
  border : 1px solid ${colorGrid.gray5};
  border-radius : 4px;
  display: flex;
  flex: 9;
  font-size: 14px;
  outline: none;
  padding : 8px 12px;
`;

const BackButton = styled(CancelButton)``;

const DTMFKeypadAndFooter = (props) => {
  return (
    <>
      <DialingInputContainer className="DTMFHeader">
        <DTMFToneContainer>
          {getIntlText(props.intl, 'SOFTPHONE-DTMF-COMMANDS', "Enter DTMF commands...")}
        </DTMFToneContainer>
      </DialingInputContainer>
      <ComposedKeypad
        cbKeyPress={props.cbHandleKeypadClick}
        dtmfOutputDeviceId={props.dtmfOutputDeviceId}
        disableDTMFTone={props.disableDTMFTone}
      />
      <FooterControls className="FooterControls" >
        <BackButton
          buttonLabel={getIntlText(props.intl, 'BACK-BTN-LABEL', "Back")}
          buttonSize="large"
          buttonType="secondary"
          cbClick={props.cbCancelDTMFOnClick}
        />
        <HangUpButton
          buttonLabel={getIntlText(props.intl, 'CALLCONTROLS-HANGUP-BTN-LABEL', "Hang Up")}
          buttonSize="large"
          buttonType="primaryRed"
          cbClick={props.cbHangupCancelDTMFOnClick}
        />
      </FooterControls>
    </>
  );
};


const ActiveUserControls = (props) => {
  const [callInfo] = useCallInfo();

  let returnJSX;

  if (props.showDTMFKeypad) {

    returnJSX = (
      <UserActions
        className="Active UserActions"
        onKeyPress={props.cbHandleKeyPress}
      >
        <DTMFKeypadAndFooter {...props} />
      </UserActions>
    );
  } else if (props.showAddCallKeypad) {
    returnJSX = (
      <UserActions
        className="Active UserActions"
        onKeyPress={props.cbHandleKeyPress}
      >
        <ComposedDialingInput
          className="DialingInput"
          cbBackspaceClick={props.cbHandleBackspaceClick}
          cbChange={props.cbHandleDialingInputChange}
          value={props.dialingInputValue}
        />
        <ComposedKeypad
          cbKeyPress={props.cbHandleKeypadClick}
          dtmfOutputDeviceId={props.dtmfOutputDeviceId}
          disableDTMFTone={props.disableDTMFTone}
        />
        <FooterControls className="FooterControls">
          <CancelButton
            buttonLabel={getIntlText(props.intl, 'CANCEL-BTN-LABEL', "Cancel")}
            buttonSize="large"
            buttonType="secondary"
            cbClick={props.cbHandleCancelAddCallClick}
          />
          <PhoneButton
            buttonSize="large"
            cbClick={props.cbHandleCallClick}
            svgType="MdPhone"
            svgFill={colorGrid.gray0}
            buttonType="primaryGreen"
            userControlStatus={props.userControlStatus}
          />
        </FooterControls>
      </UserActions>
    );

  } else {
    console.log('Render user actions.... dialing or active', props.userControlStatus);
    returnJSX = (
      <UserActions className="Active UserActions" >
        <ComposedCallControls
          isDialing={props.userControlStatus === 'dialing'}
          cbButtonClick={props.cbHandleCallControlActionClick}
          isMuted={callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].muted : false}
          isOnHold={callInfo.inprogressCalls[callInfo.activeCallId] ? callInfo.inprogressCalls[callInfo.activeCallId].held : false}
        />
      </UserActions>
    );
  }

  return returnJSX;
};


ActiveUserControls.propTypes = {
  userControlStatus: PropTypes.string,
  intl: PropTypes.object,

  cbHandleKeyPress: PropTypes.func,
  cbHandleBackspaceClick: PropTypes.func,
  cbHandleDialingInputChange: PropTypes.func,
  dialingInputValue: PropTypes.string,
  dtmfOutputDeviceId : PropTypes.string,
  cbHandleKeypadClick: PropTypes.func,
  cbHandleCallClick: PropTypes.func,
  cbCancelDTMFOnClick: PropTypes.func,
  cbHangupCancelDTMFOnClick: PropTypes.func,
  cbHandleCallControlActionClick: PropTypes.func,
  cbHandleCancelAddCallClick: PropTypes.func,
  showDTMFKeypad: PropTypes.bool,
  showAddCallKeypad: PropTypes.bool,
};

ActiveUserControls.defaultProps = {
  userControlStatus: "active",

  // cbHandleKeyPress: () => { },
  // cbHandleBackspaceClick: () => { },
  // cbHandleDialingInputChange: () => { },
  // cbHandleKeypadClick: () => { },
  // cbHandleCallClick: () => { },
  // cbCancelDTMFOnClick: () => { },
  // cbHangupCancelDTMFOnClick: () => { },
  // cbHandleCallControlActionClick: () => { },
  // cbHandleCancelAddCallClick: () => { },
};

export default injectIntl(ActiveUserControls);
